const globalMethods = {
    methods: {
        iosInputBack() {
            let ua = navigator.userAgent
            if (/MicroMessenger/i.test(ua) && /(iPhone|iPad|iPod|iOS)/i.test(ua)) {
                let inputArr = document.querySelectorAll('input');
                const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
                inputArr.forEach(item => {
                    if(!item.addMixinBlur) {
                        item.addMixinBlur = true
                        item.addEventListener('blur', () => {
                            // document.body.scrollTop = document.body.scrollTop;
                            window.scrollTo(0, Math.max(scrollHeight - 1, 0));
                        })
                    }
                })
            }
        }
    }
}

export { globalMethods }


// WEBPACK FOOTER //
// ./src/utils/mixins.js